import React, { useState } from 'react'

import { isIncognito } from 'helpers/miscellaneous'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { _isStudent } from 'store/selectors/User'
import { _iframeShareUrl } from 'store/selectors/WebSocket'

import IncognitoError from './IncognitoError'

import LeftControlBarTab from '../LeftControlBarTab'

const imgProps = {
    alt: 'jeopardy-icon',
    src: '/assets/revamp/jeopardy.svg',
    width: '80%',
    height: '80%',
}

const Jeopardy = () => {
    const { jeopardy } = useVideoContext()

    const { isIframeShared, isIFrameDisabled, toggleIframeShare } = jeopardy

    const [showErrorModal, setShowErrorModal] = useState(false)
    const closeErrorModal = () => setShowErrorModal(false)

    const handleButtonClick = async () => {
        if (isIFrameDisabled) return

        if (await isIncognito()) return setShowErrorModal(true)

        toggleIframeShare()
    }

    return (
        <>
            <LeftControlBarTab
                iconProps={imgProps}
                isEnabled={isIframeShared}
                isDisabled={isIFrameDisabled}
                onClick={handleButtonClick}
                title="jeopardy"
            />

            <IncognitoError
                isModalOpen={showErrorModal}
                onCloseModal={closeErrorModal}
            />
        </>
    )
}

export default Jeopardy
